import React from 'react';
import { Megaphone, Calendar, MapPin, Users, Target } from '@phosphor-icons/react';

export default function SpeechModule({ metadata, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...metadata, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Occasion */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Megaphone size={16} />
          Occasion (अवसर) <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={metadata.occasion || ''}
          onChange={(e) => handleChange('occasion', e.target.value)}
          placeholder="e.g., Literary Festival, Award Ceremony, Book Launch"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Date & Venue */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2 flex items-center gap-2">
            <Calendar size={16} />
            Date (तिथि)
          </label>
          <input
            type="date"
            value={metadata.date || ''}
            onChange={(e) => handleChange('date', e.target.value)}
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2 flex items-center gap-2">
            <MapPin size={16} />
            Venue (स्थान)
          </label>
          <input
            type="text"
            value={metadata.venue || ''}
            onChange={(e) => handleChange('venue', e.target.value)}
            placeholder="Location"
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
      </div>

      {/* Audience */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Users size={16} />
          Audience (श्रोता)
        </label>
        <input
          type="text"
          value={metadata.audience || ''}
          onChange={(e) => handleChange('audience', e.target.value)}
          placeholder="e.g., Writers, Students, General Public"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Speech Type */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Target size={16} />
          Speech Type (भाषण प्रकार)
        </label>
        <select
          value={metadata.speech_type || ''}
          onChange={(e) => handleChange('speech_type', e.target.value)}
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        >
          <option value="">Select type...</option>
          <option value="keynote">Keynote (मुख्य भाषण)</option>
          <option value="motivational">Motivational (प्रेरणादायक)</option>
          <option value="informative">Informative (जानकारीपरक)</option>
          <option value="commemorative">Commemorative (स्मरणात्मक)</option>
          <option value="persuasive">Persuasive (प्रभावशाली)</option>
          <option value="acceptance">Acceptance Speech (स्वीकृति भाषण)</option>
        </select>
      </div>

      {/* Duration */}
      <div>
        <label className="block text-sm font-medium mb-2">
          Duration (अवधि)
        </label>
        <input
          type="text"
          value={metadata.duration || ''}
          onChange={(e) => handleChange('duration', e.target.value)}
          placeholder="e.g., 20 minutes"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Key Themes */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Target size={16} weight="fill" className="text-blue-500" />
          Key Themes (मुख्य विषय)
        </label>
        <textarea
          value={metadata.key_themes || ''}
          onChange={(e) => handleChange('key_themes', e.target.value)}
          placeholder="Main themes and messages of the speech..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>

      {/* Call to Action */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Megaphone size={16} weight="fill" className="text-orange-500" />
          Call to Action (आह्वान)
        </label>
        <textarea
          value={metadata.call_to_action || ''}
          onChange={(e) => handleChange('call_to_action', e.target.value)}
          placeholder="What action do you want the audience to take?"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={3}
        />
      </div>
    </div>
  );
}
